import {
  GET_LOCATION_WISE_REPORT_REQUEST,
  GET_LOCATION_WISE_REPORT_SUCCESS,
  GET_LOCATION_WISE_REPORT_ERROR,
} from "../actions/types";

export const locationWise = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_LOCATION_WISE_REPORT_REQUEST:
      return {
        loading: true,
      };
    case GET_LOCATION_WISE_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_LOCATION_WISE_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};
